import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";

const AdminSEOSettings = () => {
  const [form, setForm] = useState({
    site_title: "",
    tagline: "",
    default_meta_description: "",
    default_keywords: [],
    og_image: "",
    twitter_handle: "",
  });

  const load = async () => {
    const res = await api.get("/seo/settings");
    setForm(res.data);
  };

  const save = async (e) => {
    e.preventDefault();

    try {
      await api.put("/seo/settings", form);
      toast.success("SEO settings saved successfully");
    } catch (err) {
      toast.error(err.cleanMessage || "Failed to save SEO settings");
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section>
      <div className="mb-8">
        <h1 className="text-3xl font-black text-[#061A40]">
          Global SEO Settings
        </h1>

        <p className="text-slate-500 mt-2">
          Configure default search engine optimization settings for the OGFZA
          website.
        </p>
      </div>

      <form
        onSubmit={save}
        className="bg-white rounded-3xl border border-slate-200 shadow-sm p-6 md:p-8 grid md:grid-cols-2 gap-6"
      >
        <label>
          <span className="font-bold text-sm text-slate-700">
            Site Title
          </span>

          <input
            value={form.site_title}
            onChange={(e) =>
              setForm({ ...form, site_title: e.target.value })
            }
            placeholder="Oil and Gas Free Zones Authority"
            className="mt-2 w-full border border-slate-300 rounded-2xl px-4 py-3 outline-none focus:border-[#003B73] focus:ring-4 focus:ring-[#003B73]/10"
          />
        </label>

        <label>
          <span className="font-bold text-sm text-slate-700">
            Tagline
          </span>

          <input
            value={form.tagline || ""}
            onChange={(e) =>
              setForm({ ...form, tagline: e.target.value })
            }
            placeholder="Driving Investment Through Free Zones"
            className="mt-2 w-full border border-slate-300 rounded-2xl px-4 py-3 outline-none focus:border-[#003B73] focus:ring-4 focus:ring-[#003B73]/10"
          />
        </label>

        <label className="md:col-span-2">
          <span className="font-bold text-sm text-slate-700">
            Default Meta Description
          </span>

          <textarea
            value={form.default_meta_description || ""}
            maxLength={160}
            rows="4"
            onChange={(e) =>
              setForm({
                ...form,
                default_meta_description: e.target.value,
              })
            }
            placeholder="Enter the default SEO description for the website."
            className="mt-2 w-full border border-slate-300 rounded-2xl px-4 py-3 outline-none resize-none focus:border-[#003B73] focus:ring-4 focus:ring-[#003B73]/10"
          />

          <div className="mt-2 text-xs text-slate-500">
            {form.default_meta_description?.length || 0}/160 characters
          </div>
        </label>

        <label>
          <span className="font-bold text-sm text-slate-700">
            Default Keywords
          </span>

          <input
            value={form.default_keywords?.join(", ") || ""}
            onChange={(e) =>
              setForm({
                ...form,
                default_keywords: e.target.value
                  .split(",")
                  .map((k) => k.trim())
                  .filter(Boolean),
              })
            }
            placeholder="OGFZA, Free Zones, Oil and Gas, Investment"
            className="mt-2 w-full border border-slate-300 rounded-2xl px-4 py-3 outline-none focus:border-[#003B73] focus:ring-4 focus:ring-[#003B73]/10"
          />

          <small className="block mt-2 text-slate-500">
            Separate keywords with commas.
          </small>
        </label>

        <label>
          <span className="font-bold text-sm text-slate-700">
            Twitter/X Handle
          </span>

          <input
            value={form.twitter_handle || ""}
            onChange={(e) =>
              setForm({
                ...form,
                twitter_handle: e.target.value,
              })
            }
            placeholder="@OGFZA_Nigeria"
            className="mt-2 w-full border border-slate-300 rounded-2xl px-4 py-3 outline-none focus:border-[#003B73] focus:ring-4 focus:ring-[#003B73]/10"
          />
        </label>

        <label className="md:col-span-2">
          <span className="font-bold text-sm text-slate-700">
            Default Open Graph Image URL
          </span>

          <input
            value={form.og_image || ""}
            onChange={(e) =>
              setForm({
                ...form,
                og_image: e.target.value,
              })
            }
            placeholder="https://yourdomain.com/og-image.jpg"
            className="mt-2 w-full border border-slate-300 rounded-2xl px-4 py-3 outline-none focus:border-[#003B73] focus:ring-4 focus:ring-[#003B73]/10"
          />
        </label>

        <button
          type="submit"
          className="md:col-span-2 py-4 rounded-2xl bg-[#061A40] hover:bg-[#003B73] text-white font-black transition-colors"
        >
          Save SEO Settings
        </button>
      </form>
    </section>
  );
};

export default AdminSEOSettings;